module.exports = __webpack_public_path__ + "img/sejarah_icon.f62ffb52.png";